<template>
  <VerifyAccountView />
</template>

<script setup>
import VerifyAccountView from './VerifyAccountView.vue'
</script>
